<template>
  <div>
    <Subtitle v-bind:ServiceID="this.AppServiceID">
      <template v-slot:header>
        <i class="fas fa-syringe"></i><b>Pharmacy Vaccine Request:</b>
      </template>
    </Subtitle>

    <b-modal
      id="phModal"
      modal-class="test-modal fade"
      v-model="ShowModel"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      ok-variant
      cancel-variant
      hide-footer
      header-class="PopUpHeader"
      :body-bg-variant="PopUpVar.bodyBgVariant"
      :body-text-variant="PopUpVar.bodyTextVariant"
      :footer-bg-variant="PopUpVar.footerBgVariant"
      :footer-text-variant="PopUpVar.footerTextVariant"
    >
      <template slot="modal-header">
        <div style="margin: 0 auto">
          <small class="PopUpTitle w-100 text-center"> {{ popupTitle }}</small>
        </div>
      </template>
      <AddRequest
        v-if="ShowAdd"
        v-on:finished="CloseDetailModal"
        v-bind:ClinicNo="this.ClinicNo"
      ></AddRequest>
      <EditRequest
        v-if="ShowEdit && requestDetail.length"
        v-on:finished="CloseDetailModal"
        v-bind:ClinicNo="this.ClinicNo" :showSubmit="this.showSubmit"
        :HeaderId="this.HeaderId"
        :comments ="this.Comments"
        :Wk1="this.Week1"
        :Wk2="this.Week2"
        :Wk3="this.Week3"
        :Wk4="this.Week4"
        :Week1Prods="this.Week1Products"
        :Week2Prods="this.Week2Products"
        :Week3Prods="this.Week3Products"
        :Week4Prods="this.Week4Products"
      ></EditRequest>
    </b-modal>
    <div class="col-6 pl-0" v-if="clinic.length > 0">
      <div class="card">
        <div
          class="card-header d-flex align-items-center pl-1"
          style="height: 2rem; text-align: left"
        >
          <h5>
            <small class="text-muted"
              ><b
                ><i class="fas fa-clinic-medical"></i>Clinic:
                {{ clinic[0].pname }}</b
              ></small
            >
          </h5>
        </div>
        <div class="card-body p-2 mb-0">
          <div class="row">
            <span for="cname" class="col-sm-4"><b>Clinic #:</b></span>
            <span class="col-sm-8" type="text">{{ clinic[0].clinicno }}</span>
          </div>
          <div class="row">
            <span for="cname" class="col-sm-4"><b>Address:</b></span>
            <span class="col-sm-8" type="text">{{ clinic[0].address }}</span>
          </div>
          <div class="row">
            <span for="cname" class="col-sm-4"><b>City:</b></span>
            <span class="col-sm-8" type="text">{{ clinic[0].city }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row col-12 mt-2">
      <button
        name="btnadd"
        type="button"
        v-on:click="AddEditPopup('', 'A')"
        class="btn btn-primary"
      >
        ADD NEW REQUEST
      </button>
    </div>
    <v-client-table
      class="mt-2"
      :columns="columns"
      :data="requests"
      :options="options"
    >
      <!-- <div
        class="pointer"
        v-on:click="AddEditPopup(props.row, 'E')"
        slot="edit"
        slot-scope="props"
      >
        <i class="far fa-edit"></i>
      </div> -->

      <div
        class="pointer" v-if="props.row.status==='INACTIVE'"
        v-on:click="AddEditPopup(props.row, 'V')"
        slot="edit"
        slot-scope="props"
      >
        <i class="far fa-question-circle"></i>
      </div>
      <div
        class="pointer" v-else-if="props.row.status==='ACTIVE'"
        v-on:click="AddEditPopup(props.row, 'E')"
        slot="edit"
        slot-scope="props"
      >
      <i class="far fa-edit"></i>
      </div>
    </v-client-table>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import LayoutDefault from "@/Common/Default/DefaultLayout.vue";
import Subtitle from "@/Common/Default/SubTitle.vue";
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import { PopUpVariant } from "@/Common/Default/PopUpVariant";
import { isNullOrUndefined } from "util";
import Datepicker from "vuejs-datepicker";
import Vuelidate from "vuelidate";
import { helpers } from "vuelidate/lib/validators";
import AddRequest from "@/components/Covid/AddRequest.vue";
import EditRequest from "@/components/Covid/EditRequest.vue";
import {
  required,
  minLength,
  maxLength,
  between,
  withParams,
  numeric,
} from "vuelidate/lib/validators";
const alphaNum = helpers.regex("alphaNum", /^\d{1,5}\s\w*/);
Vue.use(Vuelidate);
export default {
  props: { LeadAssessor: false, ServiceID: "" },
  data: function () {
    return {
      Comments :'',
      showSubmit: false,
      datePassed: "",
      Week1: "",
      Week2: "",
      Week3: "",
      Week4: "",
      Week1Products: [],
      Week2Products: [],
      Week3Products: [],
      Week4Products: [],
      HeaderId: "",
      clinic: [],
      popupTitle: "",
      ShowAdd: false,
      ShowEdit: false,
      ShowModel: false,
      AddEdit: "A",
      ClinicNo: "",
      clientdata: "",
      TypeHeadinptClass: "form-control",
      ShowFacilities: false,
      Facilities: "",
      SelectedFacility: "",
      SelectFacId: "",
      Patient: "",
      Risks: "",
      RisFactors: "",
      datapickClass: "form-control form-control-xs my-0",
      PopUpVar: PopUpVariant,
      effectiveDate: "",
      HSN: "",
      ProviderNo: "",
      Showinfo: false,
      showError: false,
      MsgPopup: false,
      showModal: false,
      requests: [],
      requestDetail: [],
      columns: ["status","edit" , "cutoffdate", "comments"],
      options: {
        texts: {
          count: "",
          first: "First",
          last: "Name",
          filter: "Search Request Data:",
          filterPlaceholder: "search by date",
          limit: "Records:",
          page: "Page:",
          noResults: "Vaccine request not found.",
          filterBy: "Filter by {column}",
          loading: "Loading...",
          defaultOption: "Select {column}",
          columns: "Columns",
        },

        responseAdapter({ data }) {
          return {
            data: formatData,
            count: data.length,
          };
        },
        footerHeadings: false,
        perPage: 10,
        perPageValues: [10, 15, 25],
        dateColumns: ["paymentrundate"],
        toMomentFormat: "YYYY-MM-DD",
        templates: {
          cutoffdate(h, row) {
            return moment(row.cutoffdate, "YYYY-MM-DD").format("YYYY/MM/DD");
          },
          status(h, row) {
            if (row.status == "ACTIVE") {
              return (
                <span style="color:green">
                  <i class="fas fa-check-circle"></i>
                </span>
              );
            } else if (row.status == "INACTIVE") {
              return (
                <span style="color:red">
                  <i class="fas fa-times-circle"></i>
                </span>
              );
            }
          },
        },

        headings: {
          cutoffdate: "Cut-off Date",
          // pharmacyno: "Pharmacy No",
          edit: "Edit/View", 
          status: "Status",
          comments: "Comments",
        },
        sortable: ["status"],
        filterable: "",
        sortIcon: {
          base: "fas",
          is: "fa-sort",
          up: "fa-sort-up",
          down: "fa-sort-down",
        },
      },
    };
  },
  watch: {},
  components: {
    Card,
    CardBody,
    TileNote,
    Datepicker,
    Subtitle,
    AddRequest,
    EditRequest,
  },
  filters: {
    moment: function (date) {
      return moment(date, "YYYY-MM-DD").format("YYYY/MM/DD");
    },
    stringify(value) {
      return JSON.stringify(value, null, 2);
    },
  },
  computed: {
    UserName() {
      return !this.$store.getters.GetCurrentUser
        ? false
        : this.$store.getters.GetCurrentUser;
    },
  },
  methods: {
    IsCutoffDatePassed(cDate) {
      var vm = this;
      var params = new URLSearchParams();
      params.append("Cutoffdate", cDate);
      axios
        .get("SaskHealthApi/Codes/GetIsCutoffPassed", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          vm.datePassed = response.data;
        })
        .catch(function (er) {
          if (er.status == 400) {
          } else if (er.status == 500) {
          }
        })
        .then(function () {
          vm.PharmacyRequest();
        });
    },
    CloseDetailModal() {
      this.PharmacyRequest();
      this.ShowModel = false;
    },
    GetClinicInfo() {
      var vm = this;
      var params = new URLSearchParams();
      ////console.log("username " + vm.UserName);
      params.append("username", vm.UserName);
      axios
        .get("SaskHealthApi/Codes/GetClinicinfo", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          ////console.log(response.data);
          vm.clinic = response.data;
          vm.ClinicNo = vm.clinic[0].clinicno;
          ////console.log("clinic no " + vm.ClinicNo);
        })
        .catch(function (er) {
          if (er.status == 400) {
          } else if (er.status == 500) {
          }
        })
        .then(function () {
          vm.PharmacyRequest();
        });
    },
    AddEditPopup(row, action) {
      if (action == "E") {
        this.popupTitle = "Edit Four Weeks Vaccine Request";
        this.HeaderId = row.headerid;
        this.Comments = row.comments;
        this.showSubmit = true;
        //this.IsCutoffDatePassed(row.cutoffdate);   
         this.PharmacyRequestDetail();
        //  this.ShowModel = true;
        //  this.ShowEdit = true;
        //  this.ShowAdd = false;
      } 
      else if (action == "V") {
        this.popupTitle = "View Four Weeks Vaccine Request";
        this.HeaderId = row.headerid;
         this.Comments = row.comments;
         this.showSubmit = false;
        //this.IsCutoffDatePassed(row.cutoffdate);   
         this.PharmacyRequestDetail();
 
      }
      else if (action == "A") {

        this.ShowModel = true;
        this.ShowEdit = false;
        this.ShowAdd = true;
        this.popupTitle = "Add Four Weeks Vaccine Request";
      }
    },
    PharmacyRequestDetail() {
      var vm = this;
      vm.requestDetail = [];
      var params = new URLSearchParams();
      params.append("pharmacyNo", vm.ClinicNo);
      params.append("ReqHeaderId", vm.HeaderId);
      //console.log(vm.ClinicNo);
      axios
        .get("SaskHealthApi/Codes/PharmacyRequestDetails", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          ////console.log(response.data);
          vm.requestDetail = response.data;
          //console.log(vm.requestDetail);
        })
        .catch(function (er) {
          if (er.status == 400) {
          } else if (er.status == 500) {
          }
        })
        .then(function (f) {
          if (vm.requestDetail.length > 0) {
            vm.Week1Products = [];
            vm.Week2Products = [];
            vm.Week3Products = [];
            vm.Week4Products = [];
            // if (vm.requestDetail.length === 1) {
            //   vm.Week1 = vm.requestDetail[0].reqweek;
            //   vm.Week1Products = vm.requestDetail[0];
            // }
            // if (vm.requestDetail.length === 2) {
            //   vm.Week1 = vm.requestDetail[0].reqweek;
            //   vm.Week1Products = vm.requestDetail[0];
            //   vm.Week2 = vm.requestDetail[1].reqweek;
            //   vm.Week2Products = vm.requestDetail[1];
            // }
            // if (vm.requestDetail.length === 3) {
            //   vm.Week1 = vm.requestDetail[0].reqweek;
            //   vm.Week1Products = vm.requestDetail[0];
            //   vm.Week2 = vm.requestDetail[1].reqweek;
            //   vm.Week2Products = vm.requestDetail[1];
            //   vm.Week3 = vm.requestDetail[2].reqweek;
            //   vm.Week3Products = vm.requestDetail[2];
            //   ////console.log( vm.Week3Products)
            // }
            if (vm.requestDetail.length === 4) {
              // //console.log( "req1" + vm.requestDetail[0][0].reqweek)
              vm.Week1 = vm.requestDetail[0][0].reqweek;
              vm.Week1Products = vm.requestDetail[0];
              vm.Week2 = vm.requestDetail[1][0].reqweek;
              vm.Week2Products = vm.requestDetail[1];
              vm.Week3 = vm.requestDetail[2][0].reqweek;
              vm.Week3Products = vm.requestDetail[2];
              vm.Week4 = vm.requestDetail[3][0].reqweek;
              vm.Week4Products = vm.requestDetail[3];
            }
          }
         vm.ShowModel = true;
         vm.ShowEdit = true;
         vm.ShowAdd = false;
        });
    },
    PharmacyRequest() {
      var vm = this;
      var params = new URLSearchParams();
      params.append("pharmacyNo", vm.ClinicNo);
      //console.log(vm.ClinicNo);
      axios
        .get("SaskHealthApi/Codes/PharmacyRequests", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          ////console.log(response.data);
          vm.requests = response.data;
        })
        .catch(function (er) {
          if (er.status == 400) {
          } else if (er.status == 500) {
          }
        });
    },

    Show() {
      this.Showinfo = true;
    },
    ClosePopup() {
      this.showError = false;
    },

    showMsg(msg, data, Title) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk(msg, {
          title: Title,
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Close",
          footerClass: "p-2",
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (value) {
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
  },
  created: function () {
    this.$emit("update:layout", LayoutDefault);
    this.AppServiceID = this.$store.getters.GetFHServiceID;
    this.dateFormat = this.$store.getters.GetDateFormat;
    this.ServiceDate = moment(new Date()).format("YYYY/MM/DD");
    this.GetClinicInfo();
  },
  beforeCreate: function () {
    this.$store.dispatch("AddServiceID", this.$store.getters.GetFHServiceID);
    this.$store.dispatch("GetMenuItems", this.$store.getters.GetFHServiceID);
  },
  mounted: function () {
    //this.$refs.SearchClinic.inputValue = 'Some value'
    this.$nextTick(function () {});
  },

  validations() {
    return {
      // SelectedClinic : {
      //   required,
      // },
      // selectedProvider : {
      //   required,
      // },
      HSN: {
        required,
        numeric,
        minLength: minLength(9),
      },
      effectiveDate: {
        val: (value) => this.ValidateEffectDate(),
      },
      Risks: {
        val: (value) => this.ValidateRisk(),
      },
      SelectFacId: {
        val: (value) => this.ValidateFacility(),
      },
    };
  },
};
</script>
<style scopped>
.ulClass {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0px !important;
}
.liClass {
  border: 1px solid;
  margin-bottom: 5px;
  border-radius: 5px;
  margin-right: 5px;
  padding: 0 5px;
}
.file-name {
  min-width: 150px;
  font-size: 13px;
}
.uploaded-date {
  font-size: 12px;
}
.upload-progress {
  font-size: 12px;
}
.file-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0px !important;
}
.file-details {
  margin-bottom: 0px !important;
}

.row.no-gutter [class*="col-"] {
  padding-right: 1px;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 0px 15px;
  margin-bottom: -1px;
  border: 1px solid #ddd;
  background-color: blue;
  line-height: 1em;
}
/* remove right padding from first column */
/* .row.no-gutter [class*='col-']:first-child {
  padding-right:5px;
} */
/* remove left padding from first column */
/* .row.no-gutter [class*='col-']:last-child {
  padding-left:5px;
} */

/* only for column content visible */
.col-lg-1 > div {
  background-color: #ddd;
}

#docimg {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 10px; */
}
#line {
  border-top: 1px solid rgba(7, 14, 109, 0.25);
  /* border-bottom:1px solid #c00;
  border-bottom: 1px solid rgba(255,255,255,.25); */
}
.select-css {
  display: block;
  font-size: 14px;
  /* font-family: sans-serif; */
  font-weight: 600;
  color: #444;
  line-height: 1.3;
  padding: 0.6em 1.4em 0.5em 0.8em;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 0.5em;
  -moz-appearance: none;
  -webkit-appearance: none;
  /* appearance: none; */
  background-color: #fff;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E"),
    linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
}
.select-css::-ms-expand {
  display: none;
}
.select-css:hover {
  border-color: #888;
}
.select-css:focus {
  border-color: #aaa;
  box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);
  box-shadow: 0 0 0 3px -moz-mac-focusring;
  color: #222;
  outline: none;
}
.select-css option {
  font-weight: normal;
}
#ServiceCodeGrid .VuePagination__count {
  visibility: hidden;
  height: 0px;
}
#ServiceCodeGrid .pagination {
  height: 0px;
}
/* #ServiceCodeGrid tr td:nth-child(2) {
    width: 9.5rem !important;
    padding:3px !important;
    /* margin:0rem !important;
}  */

.highlight {
  background-color: #fff2ac;
  background-image: linear-gradient(to right, #ffe359 0%, #fff2ac 100%);
}
.bd-highlight {
  /* background-color: rgba(86,61,124,0.15); */
  /* border: 1px solid rgba(86,61,124,0.15); */
  background-image: linear-gradient(to right, #ffe359 0%, #fff2ac 100%);
  /* background-image: linear-gradient(to right, #ac9732ad 0%, #cebc5985 100%); */
  /* text-decoration-line: underline; */
  font-weight: bold;
  padding: 0.4rem;
  margin: 0rem !important;
}

.cov {
  font-size: 1.3rem;
  font-weight: bolder;
  /* padding: .2rem; */
  margin: 0rem !important;
}

.test-modal .modal {
  padding: 0 !important;
  padding-left: 0px !important;
  overflow-y: scroll;
}

.test-modal .modal-dialog {
  max-width: 100%;
  height: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  z-index: 100000;
  padding-right: 0px !important;
  padding-left: 0px !important;
}

.modal-open {
  padding: 0 !important;
  padding-left: 0px !important;
  overflow-y: scroll;
}

#phModal {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>